export default __webpack_public_path__ + "static/B11-db2c258e054aa3f9898ec9025cf9f21d.png";